<main>
        <div class="contenedor">
            <!-- Header del proyecto -->
            <section class="header-proyecto">
                <div class="imagen-proyecto" style="background-image: url(https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766897830/Gemini_Generated_Image_kz6xgbkz6xgbkz6x-processed_lightpdf.com_dptcxi.png);">
                </div>
                <div class="titulo-con-flecha">
                    <a routerLink="/portafolio" class="btn-regreso">
                        <img src="assets/svg/flecha.svg" alt="Regresar">
                    </a>
                    <h1 class="titulo-proyecto">Metro de Lima – Línea 2</h1>
                </div>
                <div class="cuadro_ubicacion">
                    <div class="ubicacion-proyecto">
                    <span class="icono-ubicacion"><img src="assets/svg/IconoMap.svg" alt=""></span>
                        Lima Metropolitana
                    </div>
                </div>
                
            </section>

            <!-- Seccié³n de informacié³n del proyecto -->
            <section class="seccion-info-proyecto">
                <div class="grid-info">
                    <div class="info-columna">
                        <h3>Importancia</h3>
                        <p>Primer sistema de metro subterráneo del país. Forma parte del sistema de transporte masivo que reducirá la congestión y el tiempo de traslado en Lima, beneficiando a millones de usuarios.</p>
                    </div>
                    <div class="separador-vertical"></div>
                    <div class="info-columna">
                        <h3>Descripción del proyecto</h3>
                        <p>Proyecto de Más de 35 km de vía subterránea, 27 estaciones, 7 pozos de ventilación y un patio taller.</p>
                    </div>
                </div>
            </section>

            <!-- Sección de participación -->
            <section class="seccion-participacion">
                <div class="contenido-participacion">
                    <div class="circulo-azul-decorativo"></div>
                    <div class="info-participacion">
                        <h2>Participación de Corporación Rehobot</h2>
                        <p>Se ejecutaron trabajos especializados para <strong>captación y gestión del recurso hídrico subterráneo</strong>, incluyendo perforación, rehabilitación, equipamiento y mantenimiento de pozos, así como la implementación de sistemas auxiliares en varias estaciones.</p>
                    </div>
                    <div class="imagen-participacion"></div>
                </div>
            </section>

            <!-- Seccié³n de actividades -->
            <section class="seccion-actividades">
                <h2 class="actividades-titulo">Actividades <span>desarrolladas.</span></h2>
                <div class="contenido-actividades">
                    <div class="tarjeta-actividad">
                        <img class="img-metro" alt="">
                    </div>
                    <div class="tarjeta-lista-actividades">
                        <ul class="lista-actividades">
                            <li><strong>Estación Santa Anita:</strong> Rehabilitación y equipamiento de un pozo existente.</li>
                            <li><strong>Estación 19:</strong> Perforación de un pozo e instalación de una garza para abastecimiento mediante cisternas.</li>
                            <li><strong>Estación 20:</strong> Elaboración de estudio hidrogeológico, obtención de licencia ante la ANA, perforación del pozo y equipamiento completo.</li>
                            <li><strong>Estación 3 (Callao):</strong> Participación en el sistema de dewatering, mediante perforación de pozos y piezómetros para control del nivel freático.</li>
                            <li><strong>Mantenimiento preventivo y correctivo</strong> pozos y equipos de bombeo en las estaciones 19, 20 y Santa Anita.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Sección Más proyectos -->
            <section class="seccion-mas-proyectos">
              <div class="divisor-linea"></div>
              <h2 class="mas-proyectos-titulo">Más <span>proyectos.</span></h2>

              <div class="grid-mas-proyectos">
                <div class="tarjeta-obra-mini" *ngFor="let obra of proyectosRecomendados">
                  <div class="imagen-obra-mini"
                       [style.backgroundImage]="'url(' + obra.imagen + ')'">
                  </div>
                  <div class="contenido-mini">
                    <h3>{{ obra.titulo }}</h3>
                    <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    </main>